import './cart-mini.component.scss'
import { matchMedium } from '../../application/utils/breakpoints'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

const cartMini = document.querySelector('.cart-mini')
const cartIcon = document.querySelector('a[data-mini-cart-open]')
const miniCartBody = document.querySelector('[data-mini-cart-body]')

if (cartMini) {
  const scrollPlace = () => {
    if (matchMedium().matches) {
      return cartMini.querySelector('[data-scroll-place-mobile]')
    } else {
      return cartMini.querySelector('[data-scroll-place]')
    }
  }
  document.addEventListener('click', (event) => {
    if (
      event.target.closest('[data-mini-cart-close]') ||
      'miniCartBody' in event.target.dataset
    ) {
      event.preventDefault()
      cartMini.classList.remove('is-open')
      enableBodyScroll(scrollPlace())
    }
    if (event.target.closest('button[data-mini-cart-open]')) {
      event.preventDefault()
      cartMini.classList.add('is-open')
      cartMini.dispatchEvent(new Event('open', { bubbles: true }))
      disableBodyScroll(scrollPlace())
    }
  })
  if('ontouchstart' in window){
    cartIcon.addEventListener('click', () => {
      event.preventDefault()
      cartMini.classList.add('is-open')
      cartMini.dispatchEvent(new Event('open', { bubbles: true }))
      disableBodyScroll(scrollPlace())
    })
  }
  else{
    cartIcon.addEventListener('mouseenter', () => {
      cartMini.classList.add('is-open')
      cartMini.dispatchEvent(new Event('open', { bubbles: true }))
      disableBodyScroll(scrollPlace())
    })
    miniCartBody.addEventListener('mouseleave', () => {
      cartMini.classList.remove('is-open')
      enableBodyScroll(scrollPlace())
    })
  }
}
